import { useState } from 'react'
import { parseCookies, setCookie, destroyCookie } from 'nookies'

const useCookie = (name, initialValue = '', initialOptions = {}) => {
    const cookies = parseCookies()

    const setInitialCookieValue = () => {
        const cookieValue = cookies[name]
        if (cookieValue) return cookieValue

        setCookie(null, name, initialValue, initialOptions)
        return initialValue
    }

    const [item, setInnerValue] = useState(() => setInitialCookieValue())

    const setValue = (value, options) => {
        setInnerValue(value)
        setCookie(null, name, value, options)
    }

    return [item, setValue]
}

export { useCookie, destroyCookie }
